firebird.factory('audioFileService', [
    '$window',
    'logService',
    function ($window, logService) {
        var service = {
            playAudioFile: playAudioFile,
            playEmptyAudio: playEmptyAudio,
            playMeetingLoginChime: playMeetingLoginChime
        };

        return service;

        ////////////////////////

        function playAudioFile(path) {
            try {
                var chime = new $window.Audio(path);
                chime.play();
            } catch (e) {
                logService.log('Unable to play audio file:', e);
            }
        }

        function playEmptyAudio() {
            logService.log('Playing Empty Audio');
            service.playAudioFile('/sounds/5-seconds-of-silence.mp3');
        }

        function playMeetingLoginChime() {
            logService.log('Playing Meeting Login Chime');
            service.playAudioFile('/sounds/Your-meeting-is-starting--please-log-in.wav');
        }
    }
]);
